/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyCollect/fr/direct.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from '../index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>

                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Pour livrer le(s) produit(s) que vous avez commandé(s) dans notre magasin à l'adresse que vous avez indiquée, Xiaomi recueillera <strong>votre nom, numéro de téléphone et adresse de livraison</strong> que vous fournissez ici et les partagera avec notre partenaire de service de livraison qui vous livrera le(s) produit(s).</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">La base légale de ce traitement de vos données personnelles est qu'il est nécessaire pour <strong>exécuter un contrat auquel vous êtes partie.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Vous pouvez exercer vos droits en matière de protection de données (par exemple, accès, rectification et/ou effacement) via notre Plateforme de soutien à la confidentialité (<a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/support/</span></a>).</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Vous trouverez plus d'informations sur le traitement de vos données personnelles en vous référant à notre Politique de confidentialité (<a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span></a>).</span>
                    </span>
                </p>
            </div>
        </body>
    </html>`;


function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)